import React, { useEffect, useState } from 'react'

import { Select } from 'antd';
import { genericSearch, genericSearchBasedOnTwoFields, getCourses, getCoursesBasedOnUniversities, getMasterDataBasedOnSpecificField, getMasterDataBasedOnSpecificFiled } from '../../HttpRequest/searchcalls';
import IntakeEducation from './IntakeEducation';



const Selectcourse = ({ className, placeholder, selecteduniversity, selectedCountry, userdata, setuserdata }) => {

  const [coursename, setcourseName] = useState({
    course: "",
  });


  const [selectedcoursename, setSelectedcoursename] = useState();

  const [courseinput, setcourseinput] = useState();
  const handlechange = (value, option) => {
    console.log("---------->", value, option);
    // Use the selected value and option as needed

    setSelectedcoursename(value);
    if (selectedCountry && selecteduniversity) {
      setuserdata({
        country: selectedCountry,
        university: selecteduniversity,
        name: value
      })
    } else if (selecteduniversity) {
      setuserdata({
        university: selecteduniversity,
        name: value
      })
    } else {
      setuserdata({
        name: value
      })
    }
    // Update your state or perform other actions
    // setcourseName((prevCourseName) => ({
    //   ...prevCourseName,
    //   course: value,
    // }));
  };

  useEffect(() => {
    if (userdata) {
      console.log("user university data-->", userdata.course);
    }
    genericSearch('name', 'a', 0, 20).then((response) => {
      console.log("generic search result-->", response);
      const filteredData = response.map(country => ({
        label: country.key,
        value: country.value,
      }));
      setcourseinput(filteredData);
    });

  }, []);


  useEffect(() => {
    if (selecteduniversity && selectedCountry) {
      getCourses(selecteduniversity, selectedCountry).then((response) => {
        const filteredData = response.map(country => ({
          label: country.key,
          value: country.value,
        }));
        setcourseinput(filteredData);
        setSelectedcoursename();
      });
    }
    else if (selecteduniversity) {
      getCoursesBasedOnUniversities(selecteduniversity).then((response) => {
        const filteredData = response.map(country => ({
          label: country.key,
          value: country.value,
        }));
        setcourseinput(filteredData);
        setSelectedcoursename();
      });
    } else if (selectedCountry) {
      getMasterDataBasedOnSpecificField('country', selectedCountry, 'name', 0, 20).then((response) => {
        console.log("generic search result-->", response);
        const filteredData = response.map(country => ({
          label: country.key,
          value: country.value,
        }));
        setcourseinput(filteredData);
        setSelectedcoursename();
      });
    }
  }, [selectedCountry, selecteduniversity]);

  const onSearch = (value) => {
    if (selecteduniversity) {
      console.log("search:", value);
    } else if (selectedCountry) {
      genericSearchBasedOnTwoFields('country', selectedCountry, 'name', value, 'name', 0, 20).then((response) => {
        console.log("generic search result-->", response);
        const filteredData = response.map(country => ({
          label: country.key,
          value: country.value,
        }));
        setcourseinput(filteredData);
      });
    } else {
      console.log("search apiii:", value);
      genericSearch('name', value, 0, 20).then((response) => {
        console.log("generic search result-->", response);
        const filteredData = response.map(country => ({
          label: country.key,
          value: country.value,
        }));
        setcourseinput(filteredData);
      });
    }

  };


  const filterOption = (input, option) => {
    if (selecteduniversity) {
      return (
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      );
    }
    return true;
  };

  return (
    <>
      <Select
        showSearch
        bordered={false}
        className={className}
        placeholder={placeholder}
        optionFilterProp="children"
        name="course"
        onSearch={onSearch}
        filterOption={filterOption}
        onChange={(value, option) => handlechange(value, option)}

        style={{
          width: '320px',

          border: 'none',
          wordWrap: 'break-word',
          fontSize: '1.1rem',
          fontWeight: '500',
          whiteSpace: 'nowrap',
          overflow: 'hidden'

        }}
        options={courseinput}
        value={selectedcoursename}
      />
      <IntakeEducation userdata={userdata} setuserdata={setuserdata} Course={selectedcoursename} Country={selectedCountry} University={selecteduniversity} placeholder="Select Intake" className="cssfor" />
    </>

  )
}



export default Selectcourse